import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Valentina R.',
  location: 'Buenos Aires, Argentina',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=200&h=200',
  text: 'Sentía un bloqueo enorme con el dinero y mi propósito. Aplicar los protocolos del Tomo 3 cambió mi vibración por completo. Hoy tengo mi propia consulta online llena de pacientes.'
}, {
  name: 'Carmen M.',
  location: 'Madrid, España',
  image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&q=80&w=200&h=200',
  text: 'El nivel de detalle de este kit es impresionante. No es solo teoría, es práctica pura. La guía de limpieza energética transformó la energía de mi hogar instantáneamente.'
}, {
  name: 'Lucía F.',
  location: 'Santiago, Chile',
  image: 'https://images.unsplash.com/photo-1554727242-741c14fa561c?auto=format&fit=crop&q=80&w=200&h=200',
  text: 'Había comprado muchos cursos antes, pero ninguno con esta profundidad. Entender la mesa cuántica me dio una herramienta poderosa para sanar mi ansiedad.'
}];
export function Testimonials() {
  return <section className="py-16 relative z-10 bg-[#130b29]" data-id="element-85">
      <div className="container mx-auto px-4" data-id="element-86">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-87">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-88">
            Historias de{' '}
            <span className="text-gold-gradient" data-id="element-89">Luz y Transformación</span>
          </h2>
          <p className="text-base text-white/70 max-w-2xl mx-auto" data-id="element-90">
            Únete a miles de almas que ya han elevado su frecuencia y
            transformado su realidad.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-91">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="glass-panel rounded-2xl p-6 relative" data-id="element-92">
              <Quote className="absolute top-5 right-5 w-8 h-8 text-[#7c3aed]/20" data-id="element-93" />

              <div className="flex gap-1 mb-4" data-id="element-94">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#fbbf24] text-[#fbbf24]" data-id="element-95" />)}
              </div>

              <p className="text-white/80 italic mb-6 leading-relaxed text-sm" data-id="element-96">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-3 mt-auto" data-id="element-97">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#7c3aed]/50" data-id="element-98" />
                <div data-id="element-99">
                  <h4 className="font-cinzel font-bold text-white text-sm" data-id="element-100">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-white/50" data-id="element-101">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}